import { render, staticRenderFns } from "./HospitalPhones.vue?vue&type=template&id=6686965c&"
import script from "./HospitalPhones.vue?vue&type=script&lang=js&"
export * from "./HospitalPhones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports